// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipes_recipe__c6Iu2","images":"recipes_images__1g7LN"};